import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { Router } from '@angular/router';
import { ReserveModel, ReserveTypeModel } from './reserve.model';
import { ReserveService } from './reserve.service';
import { ReserveFormComponent } from './reserve-form.component';
import { ReserveDeleteComponent } from './reserve-delete.component';
import { ReserveConst } from './const';
import { AccountingAccountsService } from '../../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsDialogLedgerComponent } from '../../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import * as FileSaver from 'file-saver';
import { Utils } from '../../../../shared/utils';
import { consts } from '../../../../consts';

@Component({
    selector: 'app-reserve-list',
    templateUrl: './reserve-list.component.html',
    styleUrls: ['./reserve-list.component.css'],
    standalone: false
})
export class ReserveListComponent implements OnInit {
  ready = false;
  empty: boolean = true;
  headerTable: any[] = ReserveConst.headerTable;
  dataSource: ReserveModel[] = [];
  dataSourceType: ReserveTypeModel[] = [];
  constructor(
    public ReserveService: ReserveService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private router: Router,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
  ) { }

  public ngOnInit() {
    this.ReserveService.getList().then(
      data => {
        this.dataSource = data;
        this.ReserveService.getListType().then(
          dataType => {
            this.dataSourceType = dataType;
            for (const dataItem of this.dataSource) {
              const matchingType = this.dataSourceType.find(type => type.id === dataItem.reserveTypeId);
              if (matchingType) {
                dataItem.reserveTypeName = matchingType.name;
              }
            }
          });
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public create(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ReserveFormComponent, {
      width: '460px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public edit(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ReserveFormComponent, {
      width: '460px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public delete(uid: number) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ReserveDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public mayor(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    this.dialog.open(AccountingAccountsDialogLedgerComponent, {
      width: '700px',
      maxWidth: '96vw',
      
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        id: searchedElement.accountingModelsId,
        name: undefined,
        number: searchedElement.accountingModelsNumber,
      }
    });
  }

  public extracto(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    this.accountingAccountsService.excelExtractoContable(searchedElement.accountingModelsId.toString())
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Extracto contable"));
      }).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');

      });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
